// src/pages/about-us.jsx
import React, { useState, useEffect, useRef } from "react";

import "../Css/AboutUs.css";

import mainImg from "../assets/about_1.jpg";
import smallImg from "../assets/about_2.jpg";
import WhyChooseUs from "./WhyChooseUs";
import faqImg from "../assets/faq_1_1.png"; // your image

const faqData = [
  {
    q: "What kind of patient care services do your maids provide?",
    a: "Our trained maids assist with daily care for patients, including helping with mobility, medication reminders, hygiene, and providing companionship."
  },
  {
    q: "Can your maids handle baby care and housekeeping at the same time?",
    a: "Yes! Our maids are skilled in baby care, feeding, and monitoring, as well as house cleaning and maintaining a tidy home, ensuring both tasks are managed efficiently."
  },
  {
    q: "Are your maids trained in cooking?",
    a: "Absolutely. Our maids can prepare meals according to your family’s preferences, manage kitchen hygiene, and ensure nutritious and timely meals."
  },
  {
    q: "Do you provide maids for driving and errands?",
    a: "Yes, we offer trained drivers and japa maids who can safely drive your vehicle, run errands, and assist with household tasks as needed."
  }
];


const AboutUs = () => {


    const [activeIndex, setActiveIndex] = useState(null);
    const faqRef = useRef(null);


  useEffect(() => {
  const counters = document.querySelectorAll(".count");
  let started = false;

  const runCounter = () => {
    if (started) return;
    started = true;

    counters.forEach(counter => {
      const target = +counter.getAttribute("data-target");
      let count = 0;
      const speed = target > 100 ? 20 : 200;

      const updateCount = () => {
        count += Math.ceil(target / speed);
        if (count < target) {
          counter.innerText = count;
          setTimeout(updateCount, 20);
        } else {
          // Final value formatting
          if (target === 8) {
            counter.innerText = target + "y+";
          } else {
            counter.innerText = target + "+";
          }
        }
      };

      updateCount();
    });
  };






  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        runCounter();
      }
    },
    { threshold: 0.3 }
  );

  const section = document.querySelector(".about-stats-wrap");
  if (section) observer.observe(section);

  return () => observer.disconnect();
}, []);





  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("faq-visible");
          observer.unobserve(entry.target); // animate only once
        }
      },
      { threshold: 0.25 }
    );

    if (faqRef.current) observer.observe(faqRef.current);
  }, []);

  return (
    <>
      {/* ================= HERO SECTION ================= */}
      <section className="about-hero">
        <div className="about-overlay">
          <div className="about-hero-content">
            <h1>About Us</h1>
            <p>
              <span><a href="/">Home</a></span> / <span className="active">About Us</span>
            </p>
          </div>
        </div>
      </section>

      {/* ================= ABOUT INTRO SECTION ================= */}
      <section className="about-intro">
        <div className="about-intro-container">

          {/* LEFT IMAGE BLOCK */}
          <div className="about-images">
            <div className="experience-badge">
              <h2>8+</h2>
              <p>Years</p>
            </div>

            <img
              src={mainImg}
              alt="SVK Maid Service"
              className="main-img"
            />

            <div className="circle-img">
              <img src={smallImg} alt="Professional Maid" />
            </div>
          </div>

          {/* RIGHT CONTENT */}
          <div className="about-text">
            <span className="section-tag">ABOUT US</span>

            <h2>About Us – SVK Maid Service</h2>

            <p>
              SVK Maid Service is a premier provider of professional maid services.
              We connect households with skilled, verified and trustworthy domestic
              help to make everyday life easier and stress-free.
            </p>

            <ul className="about-points">
              <li>Experienced Babysitters & Nannies</li>
              <li>Same-Day or Express Service</li>
              <li>Satisfaction Guaranteed</li>
              <li>Pet Care & Daily Assistance</li>
              <li>Reliable & Verified Staff</li>
              <li>Full-Time / Part-Time Maids</li>
            </ul>

            <a href="/contact"><button className="about-btn">CONTACT US</button></a>
          </div>

        </div>
      </section>

      <WhyChooseUs />



      {/* ===== STATS SECTION ===== */}
<section className="about-stats-wrap">
  <div className="about-stats-inner">

    <div className="stat-box">
      <h3 className="count" data-target="1000">0</h3>
      <p>Customers we have served</p>
    </div>

    <div className="double-diamond"></div>

    <div className="stat-box">
      <h3 className="count" data-target="8">0</h3>
      <p>Our Experience</p>
    </div>

    <div className="double-diamond"></div>

    <div className="stat-box">
      <h3 className="count" data-target="500">0</h3>
      <p>Fulfilling client needs</p>
    </div>

  </div>
</section>

 
    <section className="faq-section" ref={faqRef}>

      <div className="faq-container">

        {/* LEFT CONTENT */}
        <div className="faq-left">
          <span className="faq-tag">FAQ</span>
          <h2 className="faq-title">
            Frequently Asked Have Any Questions
          </h2>

          {/* IMAGE FOR MOBILE */}
          <div className="faq-image-mobile">
            <img src={faqImg} alt="FAQ Maid" />
          </div>

          <div className="faq-list">
            {faqData.map((item, index) => (
              <div
  key={index}
  className={`faq-item ${activeIndex === index ? "active" : ""}`}
  onClick={() =>
    setActiveIndex(activeIndex === index ? null : index)
  }
>
  <span className="faq-underline"></span>

  <div className="faq-question">
    <h4>{item.q}</h4>
    <span className="faq-icon">
      {activeIndex === index ? "−" : "+"}
    </span>
  </div>

  <div className="faq-answer">
    <p>{item.a}</p>
  </div>
</div>

            ))}
          </div>
        </div>

        {/* IMAGE FOR DESKTOP */}
        <div className="faq-right">
          <img src={faqImg} alt="FAQ Maid Service" />
        </div>

      </div>
    </section>
    </>
  );
};

export default AboutUs;
